import { Slide } from "@jelly/lesson";

import { task as task03 } from "../../../../../task/course-04/lesson-10/task-03";

const task: Slide = {
  titleHtml:
    "What happens if an unbiased electrostatic microphone is exposed to a sinusoidal<br>acoustic signal of frequency 1 kHz?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task03.id,
        },
      },
    },
  },
};

export default task;
